import { render } from "./TypesView.vue?vue&type=template&id=5dd636c9&scoped=true"
import script from "./TypesView.vue?vue&type=script&lang=js"
export * from "./TypesView.vue?vue&type=script&lang=js"

import "./TypesView.vue?vue&type=style&index=0&id=5dd636c9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd636c9"]])

export default __exports__